// @ts-nocheck
import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

export const getUserWithdrawalLimit = () => {
  return privateRequest.get(`${ConfEnv.API_WALLET.URL_WITHDRAWAL_LIMIT}`);
};
